<template>
  <div class="login-layout" >
    <div class="login-center" :style="bg1">
      <div class="login-main w1200">
        <div class ="form-main">
          <div class="login-top">
            <img src="static/images/new_logo01.png" alt="">
            <p class="top-title">世界跆拳道协会</p>
          </div>
          <div class="form-content">
            <div class="form-item">
              <img src="/static/images/login-user.png" alt="">
              <input type="text" placeholder="请输入账号" v-model="user">
            </div>
            <div class="form-item">
              <img src="/static/images/login-pass.png" alt="">
              <input type="password" placeholder="请输入密码" v-model="pass">
            </div>
            <!-- <div class="checkbox">
              <div class="check" @click="isClick()">
                <div class="isActive">
                  <span v-if="checked"></span>
                </div>
                <p>记住密码</p>
              </div>
            </div> -->
            <div class="form-item submit-btn">
              <span class="submit-btn" @click="loginFun()">登录</span>
            </div>
            <div class="forget">
              <!-- <div style="color:#fff;cursor: pointer;">忘记密码</div> -->
              <div class="goResign">
                <span style="color:#999">还没有注册？</span>
                <span style="color:#fff;cursor: pointer;" @click="enterRegister()">点击注册</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="fixd">
      <CopyRight></CopyRight>
    </div> -->
  </div>
</template>

<script>
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import { memberLogin } from '@/api/association'
import Cookies from 'js-cookie'
import md5 from 'js-md5'
export default {
  name: 'tabs',
  components: {
    HeaderNav,
    CopyRight,
    Cookies
  },
  data () {
    return {
      titleMsg: '登录',
      checked: true,
      bg1: {
        backgroundImage: 'url(/static/images/login-bg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0px 0px',
        backgroundSize: '100% 100%'
      },
      assoInfo: JSON.parse(localStorage.getItem('assoInfo')),
      isActive: '0',
      user: '',
      pass: ''

    }
  },
  methods: {
    isClick () {
      if (this.checked) {
        this.checked = false
      } else {
        this.checked = true
      }
    },
    lfetBarClick (item) {
      this.isActive = item.id
    },
    // 登录
    loginFun () {
      if (this.user === '') {
        this.$message.error('请输入账号')
        return false
      } else if (this.pass === '') {
        this.$message.error('请输入密码')
        return false
      }
      memberLogin({ phoneNo: this.user, pwd: md5(this.pass), assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          console.log(res.data)
          let assoUserInfo = {
            phoneNo: this.user,
            pwd: md5(this.pass),
            endTime: res.data.data.endDate,
            memberCode: res.data.data.memberCode,
            memberName: res.data.data.memberName,
            memberType: res.data.data.memberType,
            rejectReason: res.data.data.rejectReason,
            status: res.data.data.status,
            memberId: res.data.data.id
          }
          // var in30Minutes = 1 / 48
          // Cookies.set('assoUserInfo', assoUserInfo, { expires: in30Minutes })
          localStorage.setItem('assoUserInfo', JSON.stringify(assoUserInfo))
          this.$router.push({
            name: 'PersonInfo'
          })
          this.$message.success('登录成功')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 去注册
    enterRegister () {
      this.$router.push({
        name: `Register`
      })
    },
    keyDown (e) {
      //
      if (e.keyCode === 13) {
        this.loginFun()
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDown)
  },
  created () {
    // if (localStorage.getItem('assoUserInfo') && localStorage.getItem('assoUserInfo') !== null) {
    //   window.open('/#/PersonInfo/', '_memberCenter')
    // }
    // this.bg1.height = this.getHeight() + 'px'
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDown, false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-layout {
    width: 100%;
    height:100vh;
  }
  .login-center {
    width: 100%;
    height: calc(100% - 118px);
    padding:125px 0px;
    /* background-color: #0a4181; */
  }
  .form-content{
    margin-top: 50px;
  }
  .form-main{
    width: 880px;
    margin: 0px auto 0px auto;
  }
  .login-top{
    text-align: center;
  }
  .login-top img{
    display: inline-block;
    width: 152px;
    height: 61px;
    overflow: hidden;
  }
  .login-top .top-title{
    font-size: 40px;
    color:#fff;
    margin-top:10px;
  }
  .form-item{
    width: 420px;
    margin: 0px auto;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-radius: 5px ;
    margin-bottom: 10px;
  }
  .submit-btn{
    width: 420px;
    text-align: center;
    background: #cc0000;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
  }
  .form-item img{
    display: block;
  }
  .form-item input{
    border: none;
    padding: 5px;
    margin-left: 10px;
    width:300px;
  }
  .form-item input:focus {
    outline:none;
    border: none;
}
.checkbox{
  width: 460px;
  margin: 0px auto;
}
.checkbox .check{
  width: 100%;
  overflow: hidden;
  margin-bottom: 10px;
  cursor: pointer;
}
.checkbox .check .isActive{
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 5px;
  position: relative;
  float: left;
}
.checkbox .check .isActive span{
  width: 12px;
  height: 12px;
  display: block;
  background: #cc0000;
  border-radius: 3px;
  position: absolute;
  left: 9px;
  top:9px;
}
.checkbox .check p{
  float: left;
  color:#fff;
  line-height: 30px;
  margin-left: 10px;
}
.forget{
  width: 460px;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
}
.fixd {
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue